<template id="salesmanDashboard">
  <section>
    <div class="card m-3">
      <div class="card-header d-flex justify-content-between">
        <div>
          <b>
            <i :class="screenletTitleInfo ? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
               ref="tooltipIcon"
               v-b-tooltip.hover.right.html="{ title: screenletTitleInfo, customClass: 'my-custom-tooltip', autoHide: false }"
               @mouseenter="showTooltip"
               @mouseleave="hideTooltip"
            >
            </i>
            {{ screenName }}
          </b>
          <span>
            (
            <span v-for="(filter, index) in selectedFiltersArray" :key="index" class="mx-1">
              <b>{{ filter.key }} :</b> {{ filter.value.Label }}<span
                v-if="index !== selectedFiltersArray.length - 1">,</span>
            </span>
            )
          </span>
        </div>
        <div>
          <button @click="showFilterDialog" class="btn btn-sm"
                  v-bind:class="{'btn-primary': filterIsSelected, 'btn-info': !filterIsSelected}">
            <span style="font-size: .7rem"><i class="fas fa-filter"></i></span>
            <span class="ml-1" v-if="!filterIsSelected">Filter</span>
            <span class="ml-1" v-else>{{ filterCount }} Filter(s) Applied</span>
          </button>
        </div>
      </div>

      <div class="card-body" v-if="loadViz">
        <div v-bind:style="{'overflow': screenletCardStyle==='flex-row-overflow' ? 'auto' : 'none'}"
             v-bind:class="screenletCardClass">
          <viz1 v-for="(r, idx) of rows" :key="vizTime + idx" ref="childComponent" :propTime="propTime"
                :viz1="vizDataRowCol[screenlet][r]" :screenlet="screenlet" :filterParam="vizFilterParams"
                :selectedFilters="staticSelectedFilters">
          </viz1>
        </div>
      </div>
    </div>
    <dialog ref="dialog">
      <input ref="hiddenInput" type="text" style="position: absolute; opacity: 0;">
      <div class="d-flex flex-column h-100">
        <button @click="hideFilterDialog" class="btn btn-outline"
                style="position: absolute; right: 10px; top: 30px;font-size: small; background-color: white">
          X
        </button>
        <h5 class="text-left mb-2 pb-2" style="border-bottom: 1px solid #ccc">Filters for {{ screenName }}</h5>
        <div class="flex-grow-1 mb-3" style="overflow-y: auto; overflow-x: hidden">
          <h5 class="text-left mb-1 pb-2" style="display: flex; justify-content: space-between">
            <i class="fas fa-cogs" style="margin-right: 8px;" title="Setup Options"> Setup Options</i>
            <button class="btn btn-sm ml-2 text-warning border border-warning" @click="resetVizFilters()" title="Reset"
                    style="background-color: transparent;">
              Reset <i class="fas fa-redo"></i>
            </button>
          </h5>
          <div class="row setup-options">
            <div v-for="(f, idx) of filtersArray"
                 :key="idx" class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column">
              <span class="text-left" style="font-size: .8rem;font-weight: bold">
                {{ f.FilterLabel || f.FilterName }}
              </span>
              <multiselect
                  v-model="selectedFilters[f.FilterName]"
                  :options="f.FilterOptions"
                  :multiple="false"
                  label="Label"
                  track-by="Value"
                  select-label="Select"
                  deselect-label="Unselect"
                  :limit="1"
                  :clear-on-select="false"
                  :append-to-body="true"
                  :preserve-search="true"
              >
              </multiselect>
            </div>
          </div>
          <h5 class="text-left mb-1 mt-3 pb-2" style="display: flex; justify-content: space-between">
            <i class="fa fa-cubes" style="margin-right: 8px;" title="Dimension Filters"> Dimension Filters</i>
            <!-- Dimension Icon -->
            <button class="btn btn-sm ml-2 text-warning border border-warning" @click="resetLb()" title="Reset"
                    style="background-color: transparent;">
              Clear <i class="fas fa-times-circle"></i>
            </button>
          </h5>
          <div class="row">
            <div v-for="(key,idx) of screenletListboxDim" :key="idx"
                 class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column">
              <span class="text-left" style="font-size: .8rem;font-weight: bold">{{ SLlistboxDimBizName[idx] }}</span>
              <div class="anyWhichWay" v-if="screenletListboxType === 'anyWhichWay'">
                <multiselect
                    v-model="filter[key]"
                    :options="listBoxOptions[key] || []"
                    :multiple="true"
                    select-label="Select"
                    deselect-label="Unselect"
                    :limit="1"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :append-to-body="true"
                    @input="optionSelected(filter)"
                >
                </multiselect>
              </div>
              <div class="freeForm" v-else>
                <multiselect
                    v-model="filter[key]"
                    :options="getFilteredValues(key)"
                    :multiple="true"
                    select-label="Select"
                    deselect-label="Unselect"
                    :limit="1"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :append-to-body="true"
                    @input="menuPath==='/post-load' ? toggleButton() : optionSelected(filter)"
                >
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button id="button" class="btn-sm btn-success"
                  @click="handleSubmit(filter)"> Submit
          </button>
        </div>
      </div>
    </dialog>
    <div>
      <common-alert
          :is-visible="invalidMenuAlert"
          :dismiss-secs="7"
          message="Invalid Menu ,redirecting to Home Page."
          variant="warning"
          @dismissed="onAlertDismissed"
      />
    </div>
    <div>
      <!-- Your existing UI -->
      <modal
          v-if="showErrorModal"
          :isVisible="showErrorModal"
          @close="showErrorModal = false"
          :title="title"
      >
        <!--        <span>Selected option is not supported.</span>-->
      </modal>
    </div>
  </section>
</template>
<script>
import Viz1 from '@/components/vizlet'
import 'vue2-datepicker/index.css';
import _ from 'lodash'
import axios from 'axios';
import Multiselect from 'vue-multiselect/src/Multiselect'
import moment from 'moment';
import CommonAlert from "@/components/CommonAlert.vue";
import Modal from "@/components/Modal.vue";
import {isDescendant} from "@/common/functions";

export default {
  name: "salesmanDashboard",
  components: {Modal, CommonAlert, Viz1, Multiselect},
  props: {
    screenlet: Number,
    sl: Object,
    scrnPropTime: Date,
    screenletId: String
  },
  watch: {
    $props: {
      handler() {
        console.log("watcvh func called", this.screenlet);
        this.loadListbox()
      },
      deep: true,
      immediate: true,
    },
    filtersArray: {
      handler() {
        // Reinitialize selectedFilters if filtersArray changes
        this.selectedFilters = {...this.initialSelectedFilters};
      },
      immediate: true,
      deep: true
    }
  },
  data: () => ({
    optionValues: ['a', 'b'],
    loadViz: false,
    menuPath: '',
    filterValues: [],
    searching: false,
    vizData: [],
    vizDataRowCol: {},
    // filterParam: {},
    screenName: '',
    time3: '',
    rows: [],
    x: {},
    filter: {},
    //x: {"d3l1_name":"All","d6l1_name":"All"},//need to revisit to make it dynamic
    propTime: null,
    y: {},
    li: 0,
    screenletListboxCount: null,
    screenletListboxCountT: 2,
    orderbyTextJson: {},
    screenletListboxDim: {},
    dateRangeFilterFlag: '',
    SLlistboxDimBizName: {},
    currentMenuActionIconsData: {},
    currentMenuListboxData: {},
    dateRangeFilterShortcuts: {},
    shortcuts: [],
    temp: [],
    promises: [],
    rowColMap: {},
    selectedKey: null,
    selectedValue: null,
    dataset: [],
    screenletListboxType: null,
    br: null,
    sm: null,
    data: [
      {label: '0'},
      {label: '2'},
      {label: '3'},
      {label: '8'},
      {label: '9'},
      {label: '11'},
      {label: '13'},
      {label: '14'},
      {label: '15'},
      {label: '18'}
    ],
    filters: [{
      nameAll: 'Select all',
      nameNotAll: 'Deselect all',
      func() {
        return true;
      },
    }],
    options: {
      multi: true,
      groups: false,
      labelName: 'label',
      labelList: 'elements',
      groupName: 'title',
      cssSelected: option => (option.selected ? {'background-color': '#5764c6'} : ''),
    },
    screenletListboxDefault: {},
    screenletCardStyle: '',
    screenletTitleInfo: '',
    listBoxOptions: {},
    listBoxCache: {},
    filterOptions: {},
    filtersArray: [],
    dataFiltersArray: [],
    selectedFilters: {},
    selectedListboxFilters: {},
    vizFilterParams: {},
    staticSelectedFilters: {},
    vizTime: null,
    invalidMenuAlert : false,
    title:"",
    showErrorModal:false
  }),
  computed: {
    filterCount() {
      const combinedFilters = {...this.filter};
      return Object.entries(combinedFilters).filter(([k, v]) => {
        console.log('k', k);
        if (Array.isArray(v)) {
          return v.some(val => val != null);
        } else if (typeof v === 'object' && v !== null) {
          return Object.values(v).some(val => val != null && val !== '');
        } else {
          return v != null && v !== '';
        }
      }).length;
    },
    filterIsSelected() {
      return this.filterCount > 0
    },
    getFilteredValues() {
      return (key1) => {
        return _.uniq(this.dataset.map(kv => kv[key1]))
            .sort((a, b) => {
              const isDateA = this.isDateRelated(a);
              const isDateB = this.isDateRelated(b);

              if (isDateA && isDateB) {
                // Both are date-related, sort in descending order
                return this.parseDate(b) - this.parseDate(a);
              }
            });
      };
    },
    screenletCardClass() {
      if (this.screenletCardStyle === 'card-deck') {
        return 'card-deck m-2'
      } else if (this.screenletCardStyle === 'flex-row-overflow') {
        return 'd-flex flex-row m-2'
      } else if (this.screenletCardStyle === 'flex-no-wrap') {
        return 'm-2'
      } else {
        return 'card-deck m-2'
      }
    },
    initialSelectedFilters() {
      const selectedFilters = {};
      this.filtersArray.forEach(filter => {
        if (filter.FilterOptions && filter.FilterOptions.length > 0) {
          selectedFilters[filter.FilterName] = filter.FilterOptions[0];
        }
      });
      return selectedFilters;
    },
    selectedFiltersArray() {
      return Object.entries(this.selectedFilters)
          .filter(([, filter]) => filter && filter.Label) // Keep entries with a valid Label
          .map(([key, filter]) => {
            // Find the corresponding filter in filterArray
            const filterDefinition = this.filtersArray.find(f => f.FilterName === key);

            // If a matching filter is found, use its FilterLabel as the new key
            const newKey = filterDefinition ? filterDefinition.FilterLabel : key;

            return {key: newKey, value: filter};
          });
    },

  },
  async created() {

    let restrictedMenu = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
    let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || [];
    const menuTree = this.$store.state.menuMasterData.filter(m => m.parentMenuId === 'Root') || []

    // Handle empty/undefined/null/["[]"] cases - all menus allowed
    const isAllMenusAllowed = !restrictedMenu ||
        restrictedMenu.length === 0 ||
        (restrictedMenu.length === 1 && restrictedMenu[0] === "[]")

    if (!isAllMenusAllowed) {
      const currentMenuId = this.$route.params.menuId
      const currentSubmenuId = this.$route.params.submenuId

      // Only check menu restrictions for routes that have these parameters
      if (currentMenuId || currentSubmenuId) {
        // Check if current IDs are in exclusion array
        const isExcluded = exclusionArray.includes(currentMenuId) ||
            exclusionArray.includes(currentSubmenuId)
        // If NEITHER menuId NOR submenuId is in the allowed list, block access
        // Check whether current IDs are directly allowed or descendants of allowed ones
        const isAllowed =
            restrictedMenu.includes(currentMenuId) ||
            restrictedMenu.includes(currentSubmenuId) ||
            isDescendant(menuTree, restrictedMenu, currentMenuId) ||
            isDescendant(menuTree, restrictedMenu, currentSubmenuId);

        if (!isAllowed || isExcluded) {
          window.alert("Invalid action, request please contact your Administrator")
          // You might want to redirect to user-restrict page here as well
          await this.$router.push('/user-restrict')
          return; // Stop execution
        }
      }
    }
    // Initialize selectedFilters when the component is created
    this.selectedFilters = {...this.initialSelectedFilters};
    this.listenToRouter()
  },
  methods: {
    onAlertDismissed() {
      this.showAlert = false; // Set showAlert to false when dismissed
      this.invalidMenuAlert = false
    },
    getDateRange(selection) {
      const filtersArray = this.filtersArray;

      const dateFormatFilterObj = filtersArray.find(
          (filter) => Object.prototype.hasOwnProperty.call(filter, "DateFormat")
      );

      const dateFormat = dateFormatFilterObj?.DateFormat;
      console.log("dateFormat", dateFormat);
      let fromDate, toDate;

      const currentYearStartDate = moment().startOf('year');
      const currentMonthStartDate = moment().startOf('month');
      const currentDate = moment();
      const currentMonth = currentDate.month();
      const financialYearStartDate =
          currentMonth >= 3 // Assuming financial year starts in April
              ? moment().month(3).startOf('month')
              : moment().subtract(1, 'year').month(3).startOf('month');

      switch (selection) {
        case 'CYTD':
          fromDate = currentYearStartDate;
          toDate = currentDate;
          break;

        case 'FYTD':
          fromDate = financialYearStartDate;
          toDate = currentDate;
          break;

        case 'L12M':
          fromDate = moment().subtract(12, 'months').startOf('month');
          toDate = moment().subtract(1, 'months').endOf('month');
          break;

        case 'YTD': // Year to Date
          fromDate = currentYearStartDate;
          toDate = currentDate;
          break;

        case 'MTD': // Month to Date
          fromDate = currentMonthStartDate;
          toDate = currentDate;
          break;

        case 'LTD': // Life to Date
          toDate = currentDate;
          break;

        default:
          return null;
      }

      return {
        fromDate: fromDate === undefined ? null : fromDate.format(dateFormat),
        toDate: toDate.format(dateFormat),
      };
    },

    getDateConfigObject() {
      const selection = this.selectedFilters?.DateRange?.Label;
      const dateField = this.selectedFilters?.DateFieldName?.Value;
      const dateRange = this.getDateRange(selection);

      const filtersArray = this.filtersArray;

      const filterWithDynParamLabel = filtersArray.find(
          (filter) => Object.prototype.hasOwnProperty.call(filter, "DynParamLabel")
      );

      const dynamicField = filterWithDynParamLabel?.DynParamLabel;
      const isDynamicFieldPresent = !!dynamicField;

      if (dateRange) {
        return {
          DateConfig:
              {
                dateField: dateField ? dateField : filtersArray[0].FilterOptions[0].Value, // Sending as a list of strings
                dynamicField: (isDynamicFieldPresent) ? [dynamicField] : [], // Value from DynParamLabel
                dateRange: {
                  fromDate: dateRange.fromDate, // Sending as a list of strings
                  toDate: dateRange.toDate, // Sending as a list of strings
                  dateShortcut: [selection], // Sending as a list of strings
                },
              },
        };
      } else {
        return {
          dateField: (dateField !== null && dateField !== undefined) ? dateField : [],
          dynamicField: (isDynamicFieldPresent) ? [dynamicField] : [], // Value from DynParamLabel
        };
      }
    },

    showFilterDialog() {
      // this.loadViz = false;
      Object.keys(this.selectedFilters).forEach(key => {
        if (this.selectedFilters[key] === null) {
          this.selectedFilters = {...this.initialSelectedFilters};
        }
      })
      this.$refs["dialog"].showModal()
    },
    hideFilterDialog() {
      this.$refs["dialog"].close()
    },
    showTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.show(); // Use the show method provided by Bootstrap-Vue
      }
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.hide(); // Use the hide method provided by Bootstrap-Vue
      }
    },
    makeFilter(rows, filterKeys) {
      //make distinct values of each col
      //total cols = 4

      let localFilters = Object.fromEntries(
          filterKeys.map(k => [k, new Set()])
      )
      for (let row of rows) {

        for (let fk of filterKeys) {
          localFilters[fk].add(row[fk])

        }

      }
      return Object.fromEntries(Object.entries(localFilters).map(x => {
        return [x[0], [...x[1]]]
      }))
    },
    async makeListBoxOptions() {
      let listboxData = this.dataset
      console.clear()

      const makeOptions = (records, filterKeys, cacheKey) => {
        //make distinct values of each col
        //total cols = 4

        //cacheKey = simply, length of row + filterKeys

        const getDistinctColValues = () => {

          //for each key, we make a set to hold distinct values
          let localFilters = Object.fromEntries(
              filterKeys.map(k => [k, new Set()])
          )

          //parse through each record
          for (let row of records) {
            //for every filter-key, we add to set, this will de-dup the data
            for (let fk of filterKeys) {
              localFilters[fk].add(row[fk])
            }
          }

          //convert to a map of {k1: [distnct values for k1], k2: [distinct values for k2] .... etc}
          return Object.fromEntries(Object.entries(localFilters).map(x => {
            return [x[0], [...x[1]].sort()]
          }))
        }

        let fromCache = false; //this.listBoxCache[cacheKey]
        //let fromCache = false
        if (cacheKey && fromCache) {
          return fromCache;
        } else {
          // let ts = new Date().getTime()
          let value = getDistinctColValues();
          this.listBoxCache[cacheKey] = value;
          return value;

        }

      }

      const applyNextFilter = (currentFilter, restOfFilters, appliedFilters) => {

        let colSelected = currentFilter[0],
            colValues = currentFilter[1];

        //say 3 filters
        //salesman, brand, store
        //when nothing is selected, then distinct values of each can be used (default)
        //say one is selected, then we use that and select distinct values for rest
        //say two is selected, then use both to select distinct values for rest


        //filter records based on applied filters
        let listboxdataCopy = [...listboxData]

        for (let restFilter of restOfFilters) {
          if (restFilter[1].length > 0) {
            listboxdataCopy = listboxdataCopy.filter(x => restFilter[1].indexOf(x[restFilter[0]]) > -1);
          }
        }

        let optionsAfterRest = makeOptions(
            listboxdataCopy,
            [colSelected],
            [...Object.entries(restOfFilters), currentFilter].map(x => `${x[0]}:${x[1].join('-')}`).join()
        )

        //select records, by applying the current filter
        let recordsAfterFilter = listboxdataCopy.filter(x => colValues.indexOf(x[colSelected]) > -1);

        //from filters, remove the current filter, and previously applied filters
        let filterRemainingKeys = Object
            .keys(listboxData[0])
            .filter(x => x !== colSelected)
            .filter(x => !appliedFilters.map(y => y[0]).includes(x))

        //now we would have gotten, distinct col values for remaining filter, based on remaining data
        let options = makeOptions(
            recordsAfterFilter,
            filterRemainingKeys,
            Object.entries(this.filter).map(x => `${x[0]}:${x[1].join('-')}`).join()
        )
        return {...options, ...optionsAfterRest}
      }

      if (this.dataset.length > 0) {

        //if filter values are selected, then apply
        let initialFilterValues = makeOptions(listboxData, Object.keys(listboxData[0]), "ALL")
        let nextFilter = null;
        //iterate through each filter
        let filterEntries = Object.entries(this.filter);
        let appliedFilters = []
        for (let currFilter of filterEntries) {

          let restOfFilters = filterEntries.filter(x => x[0] !== currFilter[0])

          //if the filter is selected
          if (currFilter[1].length > 0) {

            let prevFilter = {...(nextFilter || initialFilterValues)}
            let appliedFilter = applyNextFilter(
                currFilter,
                restOfFilters,
                appliedFilters
            )
            appliedFilters.push(currFilter)

            nextFilter = {...prevFilter, ...appliedFilter}
          }

          //else, skip this filter
        }
        return nextFilter || initialFilterValues

      } else {
        return {}

      }
    },
    async optionSelected() {
      this.listBoxOptions = await this.makeListBoxOptions()
      this.sortDateRelatedObjects(this.listBoxOptions);
      if (this.menuPath === '/post-load') await this.toggleButton()
      // else await this.loadSummary(x)
      return true
    },
    resetLb: function () {
      this.filter = {}
      // this.loadSummary(this.filter)
    },
    resetVizFilters: function () {
      this.selectedFilters = {}
      this.selectedFilters = {...this.initialSelectedFilters};
      // this.loadSummary(this.filter)
    },
    toggleButton: async function () {
      let element = document.getElementById("button");
      element.classList.remove("btn-success")
      element.classList.add("btn-warning");
    },
    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;


      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    },

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };


      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        // if (normalizedValue === key.toLowerCase()) {
        //   const currentYear = new Date().getFullYear();
        //   return new Date(currentYear, month, 1).getTime(); // Return timestamp for the first day of the month
        // }
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }

      return 0; // Default for non-date-related values
    },

    fetchListboxData: async function (sqlId) {
      await axios.get('/api/fetchListboxData/' + sqlId,{
        headers: {
          'info-params': JSON.stringify({
            menuId: this.$route.params.menuId,
            submenuId: this.$route.params.submenuId
          }),
          'Content-Type': 'application/json'
        }
      }).then(res=> {
        const removeEmptyOrNull = (obj) => {
          Object.keys(obj).forEach(k =>
              (obj[k] && typeof obj[k] === 'object') && removeEmptyOrNull(obj[k]) ||
              (!obj[k] && obj[k] !== undefined) && delete obj[k]
          );
          return obj;
        };
        let listboxData = res.data
        this.dataset = removeEmptyOrNull(listboxData) //removes the null and empty values in the resultset
        //convert set of values into an array using array.from
        //this.optionValues[index] = Array.from(new Set(resData.map(c => c.dim1).filter(x => x != null)))
        //return temp
        this.filter = Object.fromEntries(
            Object.keys(listboxData[0]).map(k => {
              return [k, []]
            })
        )
      }).catch(e=>{
        console.log("error",e);
        const errorMessage = e.response.data?.error || ''; // Get the error message safely
        // Check if the error message contains the specific phrase "Data Not Found"
        if (errorMessage.includes("Data Not Found")) {
          this.showErrorModal = true; // Show the modal for 'Data Not Found' errors
          this.title = "Data Not Found. Please contact data team.";
        }
      })

      this.listBoxOptions = await this.makeListBoxOptions()
      this.sortDateRelatedObjects(this.listBoxOptions);
    },
    sortDateRelatedObjects(listBoxOptions) {
      // Clone the object to avoid mutating the original
      const sortedOptions = { ...listBoxOptions };

      for (const key in sortedOptions) {
        const values = sortedOptions[key];
        if (Array.isArray(values)) {
          // Sort date-related values in descending order
          sortedOptions[key] = values.sort((a, b) => {
            const isADate = this.isDateRelated(a);
            const isBDate = this.isDateRelated(b);

            // Both are date-related, sort by date in descending order
            if (isADate && isBDate) {
              return this.parseDate(b) - this.parseDate(a);
            }

            // if (!this.isDateRelated(a) || !this.isDateRelated(b)) return 0;

            const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

            // Special case: Month names (case insensitive)
            if (monthPattern.test(a) && monthPattern.test(b)) {
              const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const aNormalized = a.slice(0, 3).toLowerCase(); // Normalize to lowercase
              const bNormalized = b.slice(0, 3).toLowerCase();
              return monthOrder.indexOf(bNormalized) - monthOrder.indexOf(aNormalized);
            }

            // One is date-related and the other is not
            if (isADate) {
              return -1; // Move date-related items to the front
            }

            if (isBDate) {
              return 1; // Move date-related items to the front
            }

            // Both are not date-related, sort alphabetically or numerically
            if (typeof a === 'string' && typeof b === 'string') {
              return a.localeCompare(b); // Ascending order for strings
            } else if (typeof a === 'number' && typeof b === 'number') {
              return a - b; // Ascending order for numbers
            }

            // Handle mixed data types (string vs number)
            return (typeof a < typeof b) ? -1 : 1; // Strings before numbers
          });
        }
      }

      return sortedOptions;
    },
    loadFilters: async function () {
      // let menuParam = this.$route.params.menuId
      let submenuParam = this.$route.params.submenuId

      if(submenuParam) {

        await axios.get(`/api/reportConfig/${submenuParam}`).then(config => {

          //we have config relates items
          //we shall set the options for modal dialog
          this.filterOptions = config.data.config || {}
          this.filtersArray = config.data.config.FiltersArray || []
          this.dataFiltersArray = config.data.config.ListboxIdArray || []

          this.selectedFilters = Object.fromEntries(
              this.filtersArray.map(fa => ([fa.FilterName, null]))
          )
          this.selectedListboxFilters = Object.fromEntries(
              this.dataFiltersArray.map(fa => ([fa.Field, []]))
          )

        }).catch(error => {
          console.log("error", error);
          const errorMessage = error.response.data?.error || ''; // Get the error message safely
          // Check if the error message contains the specific phrase "Data Not Found"
          if (errorMessage.includes("Data Not Found")) {
            this.showErrorModal = true; // Show the modal for 'Data Not Found' errors
            this.title = "Data Not Found. Please contact data team.";
          }
        })
      }
    },
    loadListbox: async function () {

      let submenuParam = this.$route.params.submenuId
      await this.loadFilters();
      await this.$store.dispatch("loadState")
      this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
      let menuMasterData = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam)
      if(menuMasterData.length===0 && submenuParam){
        this.invalidMenuAlert = true;
        setTimeout(() => {
          let url;

          const { homeDashboardMenuId } = this.$store.state.user;
          const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;

          if (!homeDashboardMenuId) {
            url = roleLevelMenuId || '/';
            console.log("Role level dashboard");
          } else {
            url = homeDashboardMenuId || '/';
            console.log("User level dashboard");
          }

          if (!url.includes('/')) {
            // to do need to re-look this logic
            // (checking if it is just a menu id without / then re-direct to home page)
            url = '/'
          }
          this.$router.push(url)
        }, 5000);
      }
      this.menuPath = menuMasterData[0].menuPath

      let menuData = this.$store.state.fwConfigMenuScreenRender
      let columnMetadata = this.$store.state.colummnMetaData
      let actionIconsData = this.$store.state.actionIcons
      let listboxData = this.$store.state.listbox
      let currentMenuData = [];
      if (this.screenletId) {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam)
      }

      //screenlet title info
      this.screenletTitleInfo = currentMenuData[0].screenletTitleInfo


      let screenletActionIconsSyspkArray = currentMenuData[0].screenletActionIconsSyspkArray ? currentMenuData[0].screenletActionIconsSyspkArray : []
      //let screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray
      let screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray ? currentMenuData[0].screenletListboxSyspkArray : []
      let currentMenuActionIconsData = actionIconsData.filter(r => screenletActionIconsSyspkArray.includes(r.syspk))
      let currentMenuListboxData = listboxData.filter(r => screenletListboxSyspkArray.includes(r.syspk))

      this.screenletListboxDefault = currentMenuData[0].screenletListboxDefaultValue
      this.screenletCardStyle = currentMenuData[0].screenletCardStyle
      if (this.screenletListboxDefault != null) {
        if (Object.keys(this.screenletListboxDefault).length > 0) {
          Object.keys(this.screenletListboxDefault).forEach((k) => {
            this.x[k] = this.screenletListboxDefault[k];
          })
        }
      }

      function sortFuncLB(a, b) {

        return screenletListboxSyspkArray.indexOf(a.syspk) - screenletListboxSyspkArray.indexOf(b.syspk);
      }

      function sortFuncAI(a, b) {

        return screenletActionIconsSyspkArray.indexOf(a.syspk) - screenletActionIconsSyspkArray.indexOf(b.syspk);
      }

      currentMenuListboxData.sort(sortFuncLB); //sorting the currentMenuListboxData
      currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData

      this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
      this.currentMenuListboxData = currentMenuListboxData
      this.screenletListboxCount = currentMenuListboxData.length
      this.dateRangeFilterFlag = currentMenuData[0].dateRangeFilterDisplayFlag
      this.dateRangeFilterShortcuts = currentMenuData[0].dateRangeFilterShortcuts
      this.orderbyTextJson = currentMenuData[0].orderbyTextJson
      let currentMenuListboxSQLId = currentMenuData[0].screenletListbox1_sqlId
      this.screenletListboxType = currentMenuData[0].screenletListboxType
      if (currentMenuListboxSQLId) {
        await this.fetchListboxData(currentMenuListboxSQLId);
      }


      function dateRangeCalc(date1, interval, dateType) {
        switch (dateType) {
          case 'month': {
            //let date1 = new Date();
            let firstDay = new Date(date1.getFullYear(), date1.getMonth() - interval, 1);
            let lastDay = new Date(date1.getFullYear(), date1.getMonth(), 0);
            return [firstDay, lastDay];
          }
          case 'day': {
            let firstDay = new Date();
            let dateOffset = (24 * 60 * 60 * 1000) * interval; //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
          case 'hour': {
            let firstDay = new Date();
            let dateOffset = (interval * 60 * 60 * 1000); //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
        }
      }

      //let shortcuts = []
      for (let key in this.dateRangeFilterShortcuts) {
        let value = this.dateRangeFilterShortcuts[key];
        //let shortcut = {'text':key}
        for (let inKey in value) {
          let shortcut = {
            'text': key,
            onClick() {
              let date2 = dateRangeCalc(new Date(), value[inKey], inKey);
              //const start= new Date();
              //const end= new Date(start.getTime() - 3600 * 1000 * 24*7)
              return date2
            }
          }
          this.shortcuts.push(shortcut)
        }
      }
      currentMenuListboxData.forEach((cmld, index) => {
        let bizNamefilterdim = columnMetadata.filter(c => c.columnName === cmld.listboxDimName)

        this.screenletListboxDim[index] = cmld.listboxDimName
        this.SLlistboxDimBizName[index] = bizNamefilterdim[0].bizName
      });

      if (this.menuPath !== '/post-load') {
        await this.loadSummary(this.filter);
      }

    },


    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    filteredList() {
      return this.salesmanReportData.filter(report => {
        return report.salesman.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    makeWidth: function (r, c) {
      let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
      let defV = ['2', '4', '5']
      let v = v0 && v0.length > 0 ? v0 : defV
      let lg = v[2]
      let w = ""
      let isMobile = window.innerWidth < 400
      if (isMobile) w = `width: 100%`
      else w = `width: ${lg * 10 - 5}%`
      return w
    },
    handleSubmit(x) {
      this.loadViz = false;
      this.vizTime = this.screenlet
      this.loadSummary(x);
    },
    loadSummary: async function (x) {
      this.hideFilterDialog()

      // this.filterParam = this.getDateConfigObject();
      this.vizFilterParams = _.cloneDeep(JSON.parse(JSON.stringify(this.getDateConfigObject())));
      this.staticSelectedFilters = _.cloneDeep(JSON.parse(JSON.stringify(this.selectedFilters)));

      //toggle button color when submitting
      if (document.getElementById("button")) {
        let element = document.getElementById("button");
        element.classList.remove("btn-warning")
        element.classList.add("btn-success");

      }

      this.propTime = new Date();
      this.loadViz = true
      let submenuParam = this.$route.params.submenuId

      await this.$store.dispatch("loadState")
      let allVizData = this.$store.state.fwConfigScreenElement
      console.log("allVizData", allVizData);

      if (this.screenletId) {
        this.vizDataRowCol[this.screenlet] = allVizData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        let vizTypeParamSyspk = this.selectedFilters?.["Viz Type"]?.Value?.["VizTypeParamSyspk"]
        console.log("vizTypeParamSyspk", vizTypeParamSyspk)

        let dataSql = this.selectedFilters?.["Viz Type"]?.Value?.["DataSQL"]

        if (vizTypeParamSyspk !== undefined) {
          const filter = allVizData.filter(r => r.viztype_param_syspk === vizTypeParamSyspk);
          console.log("filter", filter)
          const singleObjectArray = filter.length > 0 ? [filter[0]] : [];
          let tempArray = JSON.parse(JSON.stringify(singleObjectArray));
          console.log("tempArray", tempArray);
          console.log("dataSql", dataSql);
          console.log("singleObjectArray[0]?.reportHeaderColumnDp", singleObjectArray[0]?.reportHeaderColumnDp);
          if (
              _.has(singleObjectArray[0]?.reportHeaderColumnDp, "&dynamic_col1")
          ) {
            let tempObj = singleObjectArray[0].reportHeaderColumnDp;
            let newObj = {};

            for (const key in tempObj) {
              if (_.has(tempObj, key)) {
                if (key === "&dynamic_col1") {
                  newObj[this.selectedFilters?.DateFieldName?.Label] = tempObj[key];
                } else {
                  newObj[key] = tempObj[key];
                }
              }
            }
            tempArray[0].reportHeaderColumnDp = newObj;
          }
          console.log("tempArray[0]?.datasqlId", tempArray[0]?.datasqlId);
          tempArray[0].datasqlId = dataSql ? dataSql : tempArray[0]?.datasqlId;
          console.log("tempArray", tempArray);
          this.vizDataRowCol[this.screenlet] = tempArray;
        } else {
          this.vizDataRowCol[this.screenlet] = allVizData.filter(r => r.menuId === submenuParam);
        }

      }


      if (this.vizDataRowCol[this.screenlet].length === 0) {
        return
      }

      let menuParam = this.$route.params.menuId

      this.menuName = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
      this.menusyspk = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]


      x['fromDate'] = [this.time3[0]]
      x['toDate'] = [this.time3[1]]
      this.$store.commit('setLBwhereCond', {k: this.screenlet, v: _.extend({}, x, this.sl)})
      for (let i = 0; i < this.vizDataRowCol[this.screenlet].length; i++) {

        this.vizDataRowCol[this.screenlet][i]['f'] = _.extend({}, x, this.sl)
        this.vizDataRowCol[this.screenlet][i]['f']['fromDate'] = [this.time3[0]]
        this.vizDataRowCol[this.screenlet][i]['f']['toDate'] = [this.time3[1]]
        this.vizDataRowCol[this.screenlet][i]['fromDate'] = this.time3[0] //work around
        this.vizDataRowCol[this.screenlet][i]['toDate'] = this.time3[1] //work around

      }
      let maxRows = this.vizDataRowCol[this.screenlet].length
      this.rows = _.range(0, maxRows)
      await this.$commonFn.auditLog(this.menusyspk, submenuParam, this.menuName, this.screenName, "GET", "Success")
      // let dateFilter = {"d4l1_date": this.time3[0]}
      this.vizTime = null
    },
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from,to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        $this.rows = []
        $this.screenletListboxDim = {}
        $this.screenletListboxCount = null
        $this.optionValues = []
        //$this.x = {"d3l1_name":"All","d6l1_name":"All"},//need to revisit to make it dynamic
        $this.x = {},//revisited and made dynamic
            $this.y = {}
        $this.filter = {}
        $this.time3 = ''

        setTimeout(() => {
          if (from.matched.some(record => record.meta.requiresFlexiScreenConfig)) {
            $this.loadListbox()
          }
          //$this.loadSummary($this.x)
        }, 300)

      })
    }
  }
}
</script>
<style scope>
.cScroll {
  height: 500px;
  overflow: scroll
}

.my-custom-tooltip {
  background-color: transparent !important; /* Semi-transparent background */
  padding: 15px !important; /* Increased padding for better spacing */
  border: none !important;
  box-shadow: none !important; /* Subtle shadow for depth */
}

.my-custom-tooltip .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1200px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}


.fa-stack i:not(:first-child) {
  margin-top: 3px;
  padding-left: 18px;
}

.anyWhichWay {
  background: #c7f0c3; /* #89fb85  daf0d9 */
}

.freeForm {
  background: #91bbf0;
}


dialog {
  width: 66vw;
  height: 70vh;
  margin: auto;
  border: none;
  border-radius: 10px;
  padding: 2em;
  box-sizing: border-box; /* Include padding in the dimensions */
  overflow-y: auto; /* Enable vertical scrolling only if necessary */
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 20%); /* Light transparent white */
}

.card-body {
  padding: 0;
}

.card-body .card-deck .card {
  margin: 0 !important;
}

.h1tag {
  font-size: 20px;
  margin-bottom: 0px;
}

.lists {
  margin-top: -15px;
}

.multiselect__content-wrapper {
  top: 100% !important; /* Force dropdown to open below the input */
  bottom: auto !important; /* Prevent it from opening upwards */
  max-height: 200px; /* Limit height to prevent overflow issues */
  overflow-y: auto; /* Enable scrolling for long lists */
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border:1px solid black
}


@media (max-width: 1500px) and (min-width: 1301px) {
  .my-custom-tooltip .tooltip-inner {
    width: 950px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1300px) and (min-width: 1251px) {
  .my-custom-tooltip .tooltip-inner {
    width: 920px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1250px) and (min-width: 1201px) {
  .my-custom-tooltip .tooltip-inner {
    width: 870px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1200px) and (min-width: 1151px) {
  .my-custom-tooltip .tooltip-inner {
    width: 820px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1150px) and (min-width: 1101px) {
  .my-custom-tooltip .tooltip-inner {
    width: 770px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1100px) and (min-width: 1051px) {
  .my-custom-tooltip .tooltip-inner {
    width: 720px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1050px) and (min-width: 1001px) {
  .my-custom-tooltip .tooltip-inner {
    width: 670px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1000px) and (min-width: 951px) {
  .my-custom-tooltip .tooltip-inner {
    width: 620px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 950px) and (min-width: 901px) {
  .my-custom-tooltip .tooltip-inner {
    width: 570px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 900px) and (min-width: 851px) {
  .my-custom-tooltip .tooltip-inner {
    width: 520px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 850px) and (min-width: 801px) {
  .my-custom-tooltip .tooltip-inner {
    width: 470px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .my-custom-tooltip .tooltip-inner {
    width: 430px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }


}


@media (max-width: 768px) and (min-width: 751px) {
  .my-custom-tooltip .tooltip-inner {
    width: 650px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 750px) and (min-width: 701px) {
  .my-custom-tooltip .tooltip-inner {
    width: 600px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 700px) and (min-width: 651px) {
  .my-custom-tooltip .tooltip-inner {
    width: 550px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 650px) and (min-width: 601px) {
  .my-custom-tooltip .tooltip-inner {
    width: 500px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 600px) and (min-width: 551px) {
  .my-custom-tooltip .tooltip-inner {
    width: 450px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 550px) and (min-width: 481px) {
  .my-custom-tooltip .tooltip-inner {
    width: 370px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 480px) {
  .my-custom-tooltip .tooltip-inner {
    width: 350px; /* Further reduce the width for very small screens */
    font-size: 16px; /* Further adjust font size for very small screens */
  }

  .h1tag {
    font-size: 18px;
  }

}

/*.setup-options .multiselect {
  border: 1px solid blue;
  border-radius: 4px; !* Optional: to make the corners rounded *!
}

!* Change the selected value color to blue *!
.setup-options .multiselect__single {
  color: blue;
}

!* Adjust the hover effect for options *!
.setup-options .multiselect__option--highlight {
  background-color: rgba(0, 0, 255, 0.1); !* Light blue background on hover *!
  color: blue;
}*/
</style>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->